<h1 tabindex="-1" class="dsd-t-3">{{ 'coordonnees.titre' | translate }}</h1>

<p>{{ 'coordonnees.description' | translate }}</p>
<dsd-button
  id="boutonInformation"
  variant="tertiary"
  (dsdButtonClick)="afficherLightboxInformation()"
  class="dsd-mb-md"
>
  {{ 'coordonnees.boutonUtilisationInformation' | translate }}
</dsd-button>
<!--Courriel-->
<dsd-container>
  <p>
    <span class="libelle">{{ 'coordonnees.libelleCourriel' | translate }}&nbsp;</span>
    @if (courriel) {
      <span class="valeur">{{ courriel }}</span>
    } @else {
      <span class="valeur">{{ 'coordonnees.valeurNonPrecisee' | translate }}</span>
    }
  </p>

  <dsd-button
    id="allerAModificationCourriel"
    variant="compact"
    (dsdButtonClick)="allerAModificationCourriel()"
  >
    {{ (courriel ? 'bouton.modifier' : 'bouton.ajouter') | translate }}&nbsp;
    <span class="dsd-sr-only">
      {{ 'horsEcran.pageValidationCourriel' | translate }}
    </span>
  </dsd-button>
</dsd-container>
<!--Adresse-->
<dsd-container>
  <p>
    <span class="libelle"
      >{{
        (afficherPostdatee ? 'coordonnees.libelleAdresseCourante' : 'coordonnees.libelleAdresse')
          | translate
      }}&nbsp;</span
    >
    <span class="valeur line-data">{{ adresseCourante | adresse }}</span>
  </p>
  @if (afficherPostdatee) {
    <dsd-grid-row>
      <dsd-grid-col class="dsd-mb-0" sm-col="12" md-col="6" lg-col="4">
        <dsd-container
          border-color="dsd-color-font-decorative-graphite-200"
          border-width="double"
          border-radius="sm"
          padding="sm"
          margin="none"
        >
          <p>
            <span class="libelle">
              {{ 'coordonnees.libelleAdresseAu' | translate }}
              <span [innerHTML]="adressePostdatee.dateDebutUtilisation | dateCustom"></span
              >&nbsp;</span
            >
            <span class="valeur line-data">{{ adressePostdatee | adresse }}</span>
          </p>
          <ng-container *ngTemplateOutlet="planifierAppel"></ng-container>
        </dsd-container>
      </dsd-grid-col>
    </dsd-grid-row>
  }
  @if (peutModifierAdresse && !afficherPostdatee) {
    <dsd-button
      id="allerAModificationAdresse"
      variant="compact"
      (dsdButtonClick)="allerAModificationAdresse()"
    >
      {{ 'bouton.modifier' | translate }}&nbsp;
      <span class="dsd-sr-only">
        {{ 'horsEcran.pageValidationAdresse' | translate }}
      </span>
    </dsd-button>
  }
  @if (!peutModifierAdresse && !afficherPostdatee) {
    <ng-container *ngTemplateOutlet="planifierAppel"></ng-container>
  }
</dsd-container>
<!--Téléphone-->
<dsd-container>
  <p>
    <span class="libelle">{{ 'coordonnees.libelleTelephone' | translate }}&nbsp;</span>
    @if (telephone) {
      <span class="valeur line-data">{{ telephone | phone }}</span>
    } @else {
      <span class="valeur">{{ 'coordonnees.valeurNonPrecise' | translate }}</span>
    }
  </p>
  <dsd-button
    id="allerAModificationTelephone"
    variant="compact"
    (dsdButtonClick)="allerAModificationTelephone()"
  >
    {{ (telephone ? 'bouton.modifier' : 'bouton.ajouter') | translate }}&nbsp;
    <span class="dsd-sr-only">
      {{ 'horsEcran.pageValidationTelephone' | translate }}
    </span>
  </dsd-button>
</dsd-container>

<app-bouton-retour></app-bouton-retour>

<!-- lightbox -->
<dsd-lightbox
  id="informationsProduits"
  buttonPrimaryLabel="{{ 'bouton.fermer' | translate }}"
  [show]="lightboxAffichee"
  (dsdLightboxPrimaryClick)="cacherLightboxInformation()"
  (dsdLightboxHide)="cacherLightboxInformation()"
>
  <h2 slot="title">{{ 'coordonnees.lightboxInformation.titre' | translate }}</h2>
  <h3 class="dsd-t-6">{{ 'coordonnees.lightboxInformation.titreInclus' | translate }}</h3>
  <ul>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.1' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.2' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.3' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.4' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.5' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsInclus.6' | translate }}</li>
  </ul>
  <h3 class="dsd-t-6">{{ 'coordonnees.lightboxInformation.titreExclus' | translate }}</h3>
  <ul>
    <li>{{ 'coordonnees.lightboxInformation.produitsExclus.1' | translate }}</li>
    <li>{{ 'coordonnees.lightboxInformation.produitsExclus.2' | translate }}</li>
  </ul>
</dsd-lightbox>

<ng-template #planifierAppel>
  <p>{{ 'coordonnees.explicationModificationImpossible' | translate }}</p>
  <app-planifier-appel
    [cybermetrieLabel]="planifierAppelCybermetrieLabel"
    [cybermatrieExtraAttribut]="extraAttributCybermetrie"
  ></app-planifier-appel>
</ng-template>
